module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"add-luggages":"Ajouter des bagages","no-options":"Pas d\u0027options disponibles","type-of-flight":{"outward":"Vol aller","return":"Vol retour","common":"Vols aller et retour"}},"en":{"add-luggages":"Add luggage","no-options":"No options available","type-of-flight":{"outward":"Outward flight","return":"Return flight","common":"Outward and return flights"}}}')
  delete Component.options._Ctor
}
